/**
 * @generated SignedSource<<eaeda79bdc8676e004116c817e208945>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productListProductsDeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  productIDs: ReadonlyArray<string>;
};
export type productListProductsDeleteMutation$data = {
  readonly deleteProducts: ReadonlyArray<{
    readonly id: string;
  }> | null;
};
export type productListProductsDeleteMutation = {
  response: productListProductsDeleteMutation$data;
  variables: productListProductsDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productIDs"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "productIDs",
    "variableName": "productIDs"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productListProductsDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "deleteProducts",
        "plural": true,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productListProductsDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "deleteProducts",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dc5207381415358ee14b98a93300b258",
    "id": null,
    "metadata": {},
    "name": "productListProductsDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation productListProductsDeleteMutation(\n  $productIDs: [String!]!\n) {\n  deleteProducts(productIDs: $productIDs) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e8d89e684dafa30479b9445c85fb179f";

export default node;
